// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"77d0b028","580":"b02f6697"}[chunkId] + ".chunk.js";
};